/********************************************************************
 * ADOBE CONFIDENTIAL
 *
 * Copyright 2025 Adobe
 * All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import {style} from '@react-spectrum/s2/style' with {type: 'macro'};
import {Skeleton} from '../utils/Skeleton';

export class SideNavItemSkeleton extends Skeleton {
	public toString(): string {
		return this.wrapper({
			className: style({
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'stretch',
				justifyContent: 'start',
				gap: 8,
				width: 64,
				maxWidth: 'full',
				flexShrink: 0,
				boxSizing: 'border-box',
				paddingX: '[6px]',
				paddingBottom: '[6px]',
			}),
			children: `
                <div class="${style({width: 30, marginX: 'auto'})}">
                    ${this.image({aspect: {x: 1, y: 1}, radius: 8})}
                </div>
                ${this.caption()}
            `,
		});
	}
}

export class SideNavSkeleton extends Skeleton {
	public toString(): string {
		return this.wrapper({
			className: style({
				display: 'flex',
				flexDirection: 'column',
				alignItems: 'stretch',
				justifyContent: 'start',
				gap: 12,
				height: 'full',
				width: 64,
				maxWidth: 'full',
				minWidth: 0,
				minHeight: 0,
				paddingY: 16,
			}),
			children: `
                ${this.repeat(4, new SideNavItemSkeleton(this.props).toString())}
            `,
		});
	}
}
